/**
 * Thin wrapper around beacon sending for purposes of mocking.
 *
 * @param {string} url The URL to send the data to.
 * @param {*} data The data to send.
 */
import func from './func';

function sendBeacon(url, data) {
    return navigator.sendBeacon(url, data);
}

function postJson(url, data, callback) {
    const request = new XMLHttpRequest();

    request.addEventListener('load', function () {
        if (request.readyState === XMLHttpRequest.DONE) {
            callback(request.status, request.responseText);
        }
    });

    request.open('POST', url);
    request.setRequestHeader('Content-Type', 'application/json');
    request.send(JSON.stringify(data));
}

function get(url, headers, successCb, errorCb, completeCb) {
    const request = new XMLHttpRequest();
    successCb = func.undefinedToNoOp(successCb);
    errorCb = func.undefinedToNoOp(errorCb);
    completeCb = func.undefinedToNoOp(completeCb);

    request.addEventListener('load', function () {
        if (request.readyState === XMLHttpRequest.DONE) {
            successCb(request.status, request.responseText);
            completeCb();
        }
    });

    request.addEventListener('error', () => {
        errorCb(request.status, request.responseText);
        completeCb();
    });

    request.addEventListener('abort', () => {
        errorCb('abort');
        completeCb();
    });

    request.addEventListener('timeout', () => {
        errorCb('timeout');
        completeCb();
    });

    request.open('GET', url);

    for (const [key, value] of Object.entries(headers || {})) {
        request.setRequestHeader(key, value);
    }

    request.send();

    return request;
}

export default {
    sendBeacon: sendBeacon,
    postJson: postJson,
    get: get,
};
